import genesys from "./genesys";

const initializeGenesysSdk = (
  getDeploymentId: () => string,
  onError?: () => void,
): void =>
  genesys(
    globalThis,
    "Genesys",
    "https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js",
    {
      environment: "prod-euc1",
      deploymentId: getDeploymentId(),
    },
    onError,
  );

export default initializeGenesysSdk;
